import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca010978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "系统检测到离线故障报修数据，是否直接自动填写报修单据？", -1))
const _hoisted_3 = { class: "cache-info" }
const _hoisted_4 = { class: "van-hairline--bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "red-star" }, "故障照片")
], -1))
const _hoisted_6 = { class: "image-wrap" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick", "src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "red-star" }, "故障报修")
], -1))
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { class: "time-info" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "button-wrap" }
const _hoisted_14 = ["accept"]

import { Button, ImagePreview } from 'vant'
import { base64ToFile } from '@/utils/tools'
import { isApp, isAndrod, isIos } from '@/utils/app'
import { CacheFaultDataItem } from '@/types/malfunction-repair'
import {
  Ref,
  ref,
  withDefaults,
  onMounted,
  reactive,
  nextTick,
  computed,
} from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import dayjs from 'dayjs'
import appHost from '@/utils/app'
import CommonWrap from '@/components/popup/common-wrap.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cache-use-popup',
  props: {
    sn: { default: '' },
    canShow: { type: Boolean, default: false }
  },
  emits: ['hide', 'confirm', 'show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { sn: string, canShow: boolean };


const fileId = `fault-input_${Date.now()}`

const cacheUsePopupShow = ref(false)
const vantPopupProps = ref({
  closeOnClickOverlay: false,
})
const descriptions = computed(() => {
  if (!cacheInfo.description) {
    return []
  }
  return cacheInfo.description.split('\n')
})
const { malfunctionRepairState } = useMalfunctionRepairStore()
const inputAccept = ref('')
const cacheInfo = reactive({
  description: '',
  files: [],
  time: '',
  deviceId: '',
})
const filesInfoList: Ref<
  Array<{
    file: File
    url: string
  }>
> = ref([])
const imageList = computed(() => {
  return filesInfoList.value.map((item) => item.url)
})
function fileChangeHandle(e: any) {
  const files = e.target.files
  imageFilesHandle(files)
}
function imageFilesHandle(files: File[]) {
  const len = files.length
  for (let i = 0; i < len; i++) {
    const url = URL.createObjectURL(files[i])
    filesInfoList.value.push({
      file: files[i],
      url,
    })
  }
}
function hide() {
  appHost.deleteFaultReport(cacheInfo.deviceId)
  cacheUsePopupShow.value = false
}
function confirm() {
  emits('confirm', {
    description: cacheInfo.description,
    files: filesInfoList.value.map((item) => item.file),
    deviceId: cacheInfo.deviceId,
  })
  cacheUsePopupShow.value = false
}
function initAndroidImage(cacheItem: CacheFaultDataItem) {
  // 加载安卓图片
  // 安卓通过deviceId 拼接 file/fault_report_{deviceId} 作为accept值
  // 手动触发input file, 安卓底层通过拦截浏览器默认事件，直接触发change事件把文件返回
  inputAccept.value = `file/fault_report_${cacheItem.deviceId}`
  nextTick(() => {
    document.getElementById(fileId).click()
  })
}
async function initIosImage(cacheItem: CacheFaultDataItem) {
  const images = cacheItem.imageNames
  try {
    const files: File[] = []
    for (let i = 0; i < images.length; i++) {
      const base64Str = await appHost.getFaultReportImage(images[i])
      files.push(base64ToFile(base64Str, `${images[i]}.png`))
    }
    //const data = await Promise.all(images.map((item) => appHost.getFaultReportImage(item)))
    //const files = data.map((item, index) => base64ToFile(item, `${images[index]}.png`)) // ios目前默认图片都是png
    imageFilesHandle(files)
  } catch (error) {
    console.log('error', error)
  }
}
function initImage(cacheItem: CacheFaultDataItem) {
  // 加载缓存图片
  nextTick(() => {
    if (isIos) {
      initIosImage(cacheItem)
    } else {
      // 网页直接以安卓的方式加载图片
      initAndroidImage(cacheItem)
      // initIosImage(cacheItem)
    }
  })
}
function previewHandle(index: number) {
  ImagePreview({
    images: imageList.value,
    startPosition: index,
  })
}
async function initPageData() {
  let data: string = await appHost.getFaultReportCache()
  if (!data) {
    return
  }
  data = data.replace(/\n+/g, '\\n')
  const result: Array<CacheFaultDataItem> = JSON.parse(data)
  const snMap = result.reduce((obj, item) => {
    // item.deviceSn = 'V50PP202204250027' // 测试使用
    obj[item.deviceSn] = item
    return obj
  }, {} as Record<string, CacheFaultDataItem>)
  const current = snMap[props.sn]
  if (current) {
    // 有缓存信息询问用户是否使用
    cacheUsePopupShow.value = true
    cacheInfo.deviceId = current.deviceId
    cacheInfo.description = current.faultDescription
    if (current?.timestamp) {
      cacheInfo.time = dayjs(current.timestamp * 1000).format('YYYY:MM:DD HH:mm:ss')
    }
    initImage(current)
  }
}
onMounted(() => {
  // cacheUsePopupShow.value = true
  if (!props.canShow) {
    return
  }
  // if (malfunctionRepairState.hasUseCache) {
  //   // 已使用过的就不再使用
  //   return
  // }
  initPageData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonWrap, {
      show: cacheUsePopupShow.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((cacheUsePopupShow).value = $event)),
      title: "自动提单",
      showHeaderClose: false,
      vantPopupProps: vantPopupProps.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (!_unref(imageList).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无"))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(imageList), (item, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        onClick: ($event: any) => (previewHandle(index)),
                        key: index,
                        src: item,
                        alt: ""
                      }, null, 8, _hoisted_8))
                    }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptions), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: index
                  }, _toDisplayString(item), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (cacheInfo.time)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "更新时间：" + _toDisplayString(cacheInfo.time), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(CommonFooterWrap, { style: {"background-color":"#f6f7f8"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Button), {
                  round: "",
                  class: "cancel-button xa-vant-button",
                  onClick: hide
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("放弃填写")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  round: "",
                  class: "confirm-button xa-vant-button",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认填写")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "vantPopupProps"]),
    fileId
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "file",
          id: fileId,
          multiple: "",
          onChange: fileChangeHandle,
          accept: inputAccept.value,
          style: {"display":"none"}
        }, null, 40, _hoisted_14))
      : _createCommentVNode("", true)
  ], 64))
}
}

})